import gql from 'graphql-tag';
import { credentials } from '@shootsta/client-auth';

const getUserQuery = gql`
  query getUser($userId: String, $email: String) {
    getUser(userId: $userId, email: $email) {
      firstName
      lastName
      email
      phoneNumber
      jobTitle
      calendarLink
    }
  }
`;

const getUserDetails = () => {
  const { user: { userId, email } = {} } = credentials.get() || {};
  return {
    query: getUserQuery,
    module: 'users',
    ignoreCache: true,
    buildVariables: () => ({ userId, email })
  };
};

export default getUserDetails;